import BrazilianResidentIDHelper from '../../helpers/BrazilianResidentIDHelper';
import CheckoutOverlay from '../CheckoutOverlay';

function BrazilianResidentIDOverlay() {
  return (
    <CheckoutOverlay
      popup
      title="checkout.address.field.label.cpfBrazil.helpContent.title"
    >
      <BrazilianResidentIDHelper />
    </CheckoutOverlay>
  );
}

export default BrazilianResidentIDOverlay;
